import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GroupGuard } from '../../shared/group.guard';
import { SecurityService } from '../../shared/security.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileSyncGuard extends GroupGuard {
  constructor(securityService: SecurityService, router: Router) {
    super(securityService, router);

    this.validGroups = ["mc.emp.at.user.profile.sync"];
  }
}
